import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { Form, Input, Button, message } from 'antd'
import { signin } from '../../redux/auth'
import { reportSigninClick, reportSigninExp, reportSigninSuccess } from '../../utils/report'
import OAuth from '../../components/OAuth'
import Logo from '../../components/Logo'

class Signin extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: ''
    }
  }

  componentDidMount() {
    reportSigninExp()
    if (window) {
      window.onkeypress = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault()
          e.stopPropagation()
          this.handleClickSignin()
        }
      }
    }
  }

  componentWillUnmount() {
    if (window) {
      window.onkeypress = null
    }
  }

  handleClickSignin = () => {
    const { t } = this.props
    const { email, password } = this.state

    if (!email || !email.trim()) {
      return message.error(t('warning.emailRequired'))
    }

    if (!password || !password.trim()) {
      return message.error(t('warning.passwordRequired'))
    }

    this.props.dispatch(signin({ email, password }))
      .then((result) => {
        if (result.errorMsg) {
          return message.error(result.errorMsg)
        } else {
          this.props.history.replace('/monitor/dashboard')
        }
        reportSigninSuccess()
      }).catch((error) => {
        return message.error(t('warning.unknownError') + `:${error}`)
      })

    reportSigninClick()
  }

  handleChangeEmail = (e) => {
    const email = e.target.value
    this.setState({
      email
    })
  }

  handleChangePassword = (e) => {
    this.setState({
      password: e.target.value
    })
  }

  handleClickForget = () => {
    this.props.history.push('/forget')
  }

  handlerClickTitle = () => {
    this.props.history.push('/')
  }

  handlerClickSignup = () => {
    this.props.history.push('/signup')
  }

  render() {
    const { t } = this.props;

    return (
      <div className="area signin">
        <ul className="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <div className='form-container'>
          <Form>
            <div className='title' onClick={this.handlerClickTitle}>
              <Logo />
              <h4>{t('slogn.freeHttps')}&nbsp;•&nbsp;{t('slogn.autoUpdate')}&nbsp;•&nbsp;{t('slogn.autoDeploy')}&nbsp;•&nbsp;{t('slogn.autoMonitor')}</h4>
            </div>
            <Form.Item>
              <Input
                placeholder={t('signup.placeholderEmail')}
                onChange={this.handleChangeEmail}
              />
            </Form.Item>
            <Form.Item>
              <Input.Password
                placeholder={t('signup.placeholderPassword')}
                visibilityToggle={false}
                onChange={this.handleChangePassword}
              />
            </Form.Item>
            <Button type='primary' block onClick={this.handleClickSignin}>{t('header.login')}</Button>
            <OAuth/>
            <div style={{display: 'flex'}}>
              <Button type='link' onClick={this.handlerClickSignup}>{t('signup.noAccount')}</Button>
              <Button type='link' onClick={this.handleClickForget}>{t('signup.forgetPassword')}</Button>
            </div>
          </Form>
        </div>
      </div >
    )
  }
}

Signin = withTranslation()(connect()(Signin))

export default Signin
